import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Icon,
  Tooltip
} from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import React from 'react';

const disabilityBenefits = [
  {
    name: 'Comprehensive Own Occupation Disability',
    desc:
      'Comprehensive Own Occupational Disability (Combination of occupational disability and impairment with tiered pay-outs)',
    fmi: 'Disability Lump Sum - Comprehensive',
    hollard: 'Comprehensive Disabilty Benefit - Own Occupation',
    liberty: 'Absolute Protector (OOD) (Plus)',
    momentum: 'Comprehensive Disability Benefit',
    sanlam:
      'Functional Impairment plus Disability for Regular Occupation (CAR) CSR)'
  },
  {
    name: 'Comprehensive Own or Similar Occupation Disability',
    desc:
      'Comprehensive Own or Similar Occupational Disability (Combination of occupational disability and impairment with tiered pay-outs)',
    fmi: 'Disability Lump Sum - Comprehensive',
    hollard: 'Comprehensive Disabilty Benefit - Own/Similar Occupation',
    liberty: 'Absolute Protector (OD) (Plus)',
    momentum: 'Comprehensive ADW Disability Benefit',
    sanlam:
      'Functional Impairment plus Disability for Regular and Reasonable Alternative Occupation (CAS) (CSS)'
  },
  {
    name: 'Own Occupation Disability',
    desc: 'Own Occupational Disability (Only 100% claim - no tiered payments)',
    fmi: 'Disability Lump Sum - Occupational',
    hollard: 'Core Disability Benefit - Own Occupation',
    liberty: 'Capital Disability (OOD) (Plus)',
    momentum: 'Own Occupation Disability Benefit ',
    sanlam: 'Disability for Regular Occupation (OAR) (OSR)'
  },
  {
    name: 'Own/Similar occupation ',
    desc:
      'Own or Similar Occupational Disability (Only 100% claim - no tiered payments)',
    fmi: 'Disability Lump Sum - Occupational',
    hollard: 'Core Disability Benefit - Own/Similar Occupation',
    liberty: 'Capital disability (OD) (Plus)',
    momentum: 'ADW Disability Benefit',
    sanlam:
      'Disability for Regular and Reasonable Alternative Occupation (OAS) (OSS)'
  },
  {
    name: 'Impairment',
    desc: 'Impairment',
    fmi: 'Disability Lump Sum - Occupational',
    hollard: 'Comprehensive Impairment',
    liberty: 'Impairment (Plus)',
    momentum: 'Functional Impairment',
    sanlam: 'Functional impairment (OAF) (OSF)'
  }
];

const criticalIllnessBenefits = [
  {
    name: 'Enhanced',
    desc: 'Most comprehensive critical illness on offer',
    fmi: 'Critical illness -Include Top-up',
    hollard: 'Comprehensive Critical Illness (Max)',
    liberty: 'Living Livestyle with Top up and Extended Options (Plus)',
    momentum: 'Complete Enhanced Critical Illness',
    sanlam: 'Comprehensive Severe Illness Plus (TAW4) (TSW4)'
  },
  {
    name: 'Standard',
    desc: 'Critical Illness without SCIDEP claims 100%',
    fmi: 'Critical illness -Include Extender',
    hollard: 'Comprehensive Severe Illness (Severity based)',
    liberty: 'Living Livestyle with Extended Option (Plus)',
    momentum: 'Complete Critical Illness Benefit',
    sanlam: 'Comprehensive Severe Illness (TAW3) (TSW3)'
  }
];

const temporaryIncomeBenefit = [
  {
    name: 'Temporary income protector',
    desc: '24 months payment',
    fmi: 'Temporary Income Protector',
    hollard: 'Compehensive Disability Income Benefit',
    liberty: 'Absolute Income Protector Benefit',
    momentum: 'Temporary Income Protector Benefit',
    sanlam: 'Temporary Disability Income Benefit (OIT3)'
  }
];

const extendedIncomeBenefit = [
  {
    name: 'Extended income protector',
    desc: '24 months waiting period',
    fmi: 'Extended Income Protector',
    hollard: 'Compehensive Disability Income Benefit',
    liberty: 'Extended Absolute Income Protector Benefit',
    momentum: 'Income Protector Benefit',
    sanlam: 'Extended Disability Income Benefit (OIO3)'
  }
];

class BenefitMapping extends React.Component {
  render() {
    return (
      <div className='contentWithStepper'>
        <Card className={this.classes}>
          <CardContent>
            <CustomCardHeading
              subheading='Quote Generation'
              caption={this.props.clientFullname}
              headline='Benefit Mapping'
            />
            <div
              style={{
                maxHeight: 600,
                overflowY: 'auto'
              }}
            >
              <Table className='customTable1'>
                <TableHead className='fixedHead'>
                  <TableRow>
                    <TableCell>Sure-Quote</TableCell>
                    <TableCell>Bidvest</TableCell>
                    <TableCell>Hollard</TableCell>
                    <TableCell>Liberty</TableCell>
                    <TableCell>Momentum</TableCell>
                    <TableCell>Sanlam</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>Death Benefits</strong>
                    </TableCell>
                    <TableCell />
                    {Array(4)
                      .fill('')
                      .map(x => (
                        <TableCell />
                      ))}
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography>Life cover</Typography>
                      <Tooltip title='Life cover'>
                        <Icon style={{ color: '#95acbd' }}>info</Icon>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography>Life Lump Sum</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Life Cover Benefit</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Life Cover</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Death Benefit</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>Death (DS)</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Disability benefits</strong>
                    </TableCell>
                    <TableCell />
                    {Array(4)
                      .fill('')
                      .map(x => (
                        <TableCell />
                      ))}
                  </TableRow>
                  {disabilityBenefits.map(ben => (
                    <TableRow>
                      <TableCell>
                        <Typography>{ben.name}</Typography>
                        <Tooltip title={ben.desc}>
                          <Icon style={{ color: '#95acbd' }}>info</Icon>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.fmi}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.hollard}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography> {ben.liberty}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.momentum}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.sanlam}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell>
                      <strong>Critical illness benefits</strong>
                    </TableCell>
                    <TableCell />
                    {Array(4)
                      .fill('')
                      .map(x => (
                        <TableCell />
                      ))}
                  </TableRow>
                  {criticalIllnessBenefits.map(ben => (
                    <TableRow>
                      <TableCell>
                        <Typography>{ben.name}</Typography>
                        <Tooltip title={ben.desc}>
                          <Icon style={{ color: '#95acbd' }}>info</Icon>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.fmi}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.hollard}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography> {ben.liberty}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.momentum}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.sanlam}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell>
                      <strong>Temporary income benefits</strong>
                    </TableCell>
                    <TableCell />
                    {Array(4)
                      .fill('')
                      .map(x => (
                        <TableCell />
                      ))}
                  </TableRow>
                  {temporaryIncomeBenefit.map(ben => (
                    <TableRow>
                      <TableCell>
                        <Typography>{ben.name}</Typography>
                        <Tooltip title={ben.desc}>
                          <Icon style={{ color: '#95acbd' }}>info</Icon>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.fmi}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.hollard}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography> {ben.liberty}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.momentum}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.sanlam}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell>
                      <strong>Extended income benefits</strong>
                    </TableCell>
                    <TableCell />
                    {Array(4)
                      .fill('')
                      .map(x => (
                        <TableCell />
                      ))}
                  </TableRow>
                  {extendedIncomeBenefit.map(ben => (
                    <TableRow>
                      <TableCell>
                        <Typography>{ben.name}</Typography>
                        <Tooltip title={ben.desc}>
                          <Icon style={{ color: '#95acbd' }}>info</Icon>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.fmi}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.hollard}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography> {ben.liberty}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.momentum}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{ben.sanlam}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default BenefitMapping;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/BenefitMapping.jsx